module.exports = __webpack_public_path__ + "img/icon-png.35786a58.svg";